module.exports = __webpack_public_path__ + "static/media/codeforall_logo.36d2cf63.jpeg";